import RowText from "@/components/input-formvuelate/RowText.vue";
import { ValueType } from "@/enums/ValueType";
import type { SchemaType } from "@/models/domain/SchemaType";

export const maximaleHypotheekSchema = {
	toetsinkomen: {
		component: RowText,
		label: "Toetsinkomen",
		readOnly: true,
		valueType: ValueType.Currency as const,
	},
	toetsinkomenPerMaand: {
		component: RowText,
		label: "Toetsinkomen per maand",
		readOnly: true,
		valueType: ValueType.Currency as const,
	},
	gewogenToetsrente: {
		component: RowText,
		label: "Gewogen toetsrente leningdelen",
		readOnly: true,
		valueType: ValueType.Percentage as const,
	},
	maximaleLooptijd: {
		component: RowText,
		label: "Maximale looptijd",
		readOnly: true,
		valueType: ValueType.Number as const,
	},
} satisfies SchemaType;

export const toegestaneLastenSchema = {
	maxLeningInkomenLasten: {
		component: RowText,
		label: "Maximale hypotheek (LTI max.)",
		readOnly: true,
		valueType: ValueType.Currency as const,
	},
	toetsAnnuiteitenFactor: {
		component: RowText,
		label: "Toetsannuiteitenfactor",
		readOnly: true,
		valueType: ValueType.Number as const,
		precision: 8,
	},
	toegestaneMaandlast: {
		component: RowText,
		label: "Toegestane maandlast",
		readOnly: true,
		valueType: ValueType.Currency as const,
	},
	maximaleFinancieringslast: {
		component: RowText,
		label: "Toegestane jaarlast",
		readOnly: true,
		valueType: ValueType.Currency as const,
	},
} satisfies SchemaType;

export const ltvSchema = {
	somVanLeningdelen: {
		component: RowText,
		label: "Som van leningdelen",
		readOnly: true,
		valueType: ValueType.Currency as const,
	},
	marktwaarde: {
		component: RowText,
		label: "Marktwaarde",
		readOnly: true,
		valueType: ValueType.Currency as const,
	},
	ltv: {
		component: RowText,
		label: "LTV (loan-to-value)",
		readOnly: true,
		valueType: ValueType.Percentage as const,
	},
} satisfies SchemaType;

export const woonquoteSchema = {
	woonquoteBox1: {
		component: RowText,
		label: "Woonquote box 1",
		readOnly: true,
		valueType: ValueType.Percentage as const,
	},
	woonquoteBox3: {
		component: RowText,
		label: "Woonquote box 3",
		readOnly: true,
		valueType: ValueType.Percentage as const,
	},
} satisfies SchemaType;
